import styled from '@emotion/styled';
import { desktopOnly, focusRingStyle, mobileOnly } from '../../utils/sharedStyles';

export const brandList = 'brand-list';
export const jordanClass = 'brand-jordan';
export const converseClass = 'brand-converse';
export const brandLinkClass = 'brand-link';

export const StyledUl = styled.ul`
  ${props => `background: ${props.backgroundColor};`}

  .${converseClass}:hover, & .${jordanClass}:hover {
    opacity: 0.5;
  }

  @media (${desktopOnly}) {
    gap: 24px;
    align-items: center;
  }

  .${brandLinkClass} {
    color: var(--podium-cds-color-text-primary);
    display: flex;
    padding: 8px 24px 8px 30px;
    ${focusRingStyle}
    p {
      padding-left: 12px;
    }
    @media (${mobileOnly}) {
      svg {
        transform: scale(1.33);
      }
    }
    @media (${desktopOnly}) {
      padding: 0;
    }
  }
`;
